import { buildGetApiClient } from '@b-stock/fe-core/bstock-next/queries'
import { ListingViewsApi } from '@b-stock/search-api-client'

const getListingViewsClient = buildGetApiClient('SEARCH', ListingViewsApi)

export default getListingViewsClient
